import React from 'react';

export function MetricGrid({ className = '', children }) {
  return <section className={`mb-4 grid gap-3 md:grid-cols-2 xl:grid-cols-4 ${className}`}>{children}</section>;
}

export function SplitGrid({ className = '', children }) {
  return <section className={`mb-4 grid gap-4 lg:grid-cols-[2fr_1fr] ${className}`}>{children}</section>;
}
